<div class="module1">
    <img src="photo/IMG_module1_1.jpg" class="photo1" alt="фото_1" />
</div>

<style>
    .module1 {
        width: fit-content;
        margin: 0 auto;
        /* margin-top: -50px; */
        position: relative;
    }

    .photo1 {
        /* width: 50%; */
        display: block;
        margin: 0 auto;
        position: relative;
        /* filter: brightness(80%); */
    }

    @media (min-width: 1280px) {
        .photo1 {
            width: 50%;
        }
    }
    @media (max-width: 480px) {
        .photo1 {
            width: 100%;
        }
    }
    @media (min-width: 481px) and (max-width: 833px) {
        /*Телефон горизонталь*/
        .photo1 {
            width: 100%;
        }
    }
    @media (min-width: 834px) and (max-width: 1023px) {
        /*Планшет*/
        .photo1 {
            width: 100%;
        }
    }
    @media (min-width: 1024px) and (max-width: 1279px) {
        .photo1 {
            width: 100%;
        }
    }
</style>
